module.exports = __webpack_public_path__ + "static/media/img_Inscription_free2.45e8fbee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_free2.png
// module id = 984
// module chunks = 0